<template>
<div class="chapter">
<div class="inner_page">
<p class="head2"><a id="page_xv"><img alt="image" src="images/half1.jpg"/> <span class="small">ABBREVIATIONS</span></a></p><a id="page_xv">
<table width="100%">
<colgroup><col width="15%"/>
<col width="85%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="noindent">Ant tard.</p></td>
<td valign="top"><p class="noindent">Antiquité tardive</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">BMGS</p></td>
<td valign="top"><p class="noindent">Byzantine and Modern Greek Studies</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">DOP</p></td>
<td valign="top"><p class="noindent">Dumbarton Oaks Papers</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">EHR</p></td>
<td valign="top"><p class="noindent">English Historical Review</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">JHS</p></td>
<td valign="top"><p class="noindent">Journal of Hellenic Studies</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">JÖB</p></td>
<td valign="top"><p class="noindent">Jahrbuch der Österreichischen Byzantinistik</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">JRA</p></td>
<td valign="top"><p class="noindent">Journal of Roman Archaeology</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">JRS</p></td>
<td valign="top"><p class="noindent">Journal of Roman Studies</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">PBSR</p></td>
<td valign="top"><p class="noindent">Papers of the British School at Rome</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">PG</p></td>
<td valign="top"><p class="noindent">Patrologia Graeca</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">REB</p></td>
<td valign="top"><p class="noindent">Revue des Études Byzantines</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">TIB</p></td>
<td valign="top"><p class="noindent">Tabula Imperii Byzantini</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">TM</p></td>
<td valign="top"><p class="noindent">Travaux et Mémoires</p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abb.vue?0ba2d2f8